let language = {
    "TAXES-HEADING-UK": "欧盟和英国",
    "TAXES-HEADING-US": "美国",
    "TAXES-EN-UK-CONTAINER-DESCRIPTION1": `所有发往欧盟 (EU) 和英国的订单均需缴纳增值税。为确保准确计算税款，请向我们提供贵公司的增值税 ID 号，该号码也用于计费目的。`,
    "TAXES-EN-UK-CONTAINER-DESCRIPTION2": `请注意，增值税 ID 的提交与 IOSS 号码不同。如果您在提交增值税 ID 时需要帮助，请随时与我们联系。`,
    "TAXES-ACCOUNT-DETAILS-TITLE": "账户详细资料",
    "TAXES-ACCOUNT-DETAILS-BUTTON-EDIT": "在我的账户中编辑",
    "TAXES-ACCOUNT-DETAILS-BUTTON-EDIT-XS": "编辑",
    "TAXES-ACCOUNT-DETAILS-BUSINESS-SUBTITLE": "公司名称",
    "TAXES-ACCOUNT-DETAILS-BUSINESS-COMPLETED": "没完成",
    "TAXES-ACCOUNT-DETAILS-ACCOUNT-TIPS": "请填写您的账户资料",
    "TAXES-ACCOUNT-DETAILS-ACCOUNT-BUTTON": "Add detail",
    "TAXES-ACCOUNT-DETAILS-ACCOUNT-DETAIL-SUBTITLE": "增值税号",
    "TAXES-ACCOUNT-ACCOUNT-VAT-LIST-BUTTON": "删除",
    "TAXES-STATUS-CONTAINER-VALID": "有效的",
    "TAXES-STATUS-CONTAINER-PENDING": "待办的",
    "TAXES-STATUS-CONTAINER-INVALID": "无效的",
    "TAXES-VAT-FORM-BOX-TITLE": "提交增值税",
    "TAXES-VAT-FORM-BOX-COUNTRY": "国家",
    "TAXES-VAT-FORM-BOX-ID": "增值税号",
    "TAXES-VAT-FORM-BOX-ID-PLACEHODER": "例如 : DE123456789",
    "TAXES-VAT-FORM-BOX-ID-TIPS": "该号码似乎不正确。请检查",
    "TAXES-VAT-FORM-ADD-PREADD-VAT": "添加其他国家的增值税ID",
    "TAXES-VAT-FORM-CUSTOM-AFFIRM-TEXT": `我在此确认所提供的增值税识别号已分配给我的企业，并且应在今后用于识别我的企业以用于计费和税务报告目的。`,
    "TAXES-VAT-FORM-BUTTON-SUBMIT":"提交增值税号",

    "TAXES-US-DESCRIPTION1":"{{appName}}对运往美国 {{appName}}注册销售税的州的订单征收销售税。",
    "TAXES-US-EXEMPTION-TITLE":"转售和销售税豁免证明",
    "TAXES-US-DESCRIPTION2":`如果您已注册销售税征收，则可以申请转售证书。有效的转售证书可使您有资格在通过 QPMN 下达的订单上获得销售税豁免。营业执照、销售许可证或其他文件本身并不等同于转售证书。但是，您可以填写下面的转售证书表格，并在选定州的订单上获得免税。`,
    "TAXES-US-CERTIFICATES-TIPS":"证书将在一周内审核，如果需要任何更改，我们将通知您。",
    "TAXES-US-BUTTON-SUBMIT":"提交证书",
    "TAXES-US-JURSDICTIONS-TABLE-NO":"序号",
    "TAXES-US-JURSDICTIONS-TABLE-JURSDICTIONS":"豁免的管辖范围",
    "TAXES-US-JURSDICTIONS-TABLE-EXEMPTION-ID":"豁免 ID",
    "TAXES-US-JURSDICTIONS-TABLE-FORMS":"形式",
    "TAXES-US-JURSDICTIONS-TABLE-STATUS":"审核状态",

    // 问卷
    "TAXES-US-MODAL-FOOTER-CANCEL":"取消",
    "TAXES-US-MODAL-FOOTER-BACK":"返回",
    "TAXES-US-MODAL-FOOTER-SKIP":"跳过",
    "TAXES-US-MODAL-FOOTER-NEXT":"下一个",
    "TAXES-US-MODAL-FOOTER-SUBMIT":"提交",
    "TAXES-US-MODAL-FOOTER-DONE":"完成",

    // STEP1
    "TAXES-US-MODAL-STEP1-TITLE":"豁免证书向导",
    "TAXES-US-MODAL-STEP1-DESCRIPTION":"选择豁免的司法管辖区",
    "TAXES-US-MODAL-STEP1-CONTENT-US":"美国",

    // STEP2
    "TAXES-US-MODAL-STEP2-TITLE":"豁免证书向导",
    "TAXES-US-MODAL-STEP2-DESCRIPTION":"请选择豁免的任何地方司法管辖区 : ",
    "TAXES-US-MODAL-STEP2-EMPTY-TIPS":"目前所选的管辖地区没有问卷调查",
    
    // STEP3
    "TAXES-US-MODAL-STEP3-TITLE":"豁免证书向导",
    "TAXES-US-MODAL-STEP3-DESCRIPTION":"您正在为创建证书",
    "TAXES-US-MODAL-STEP3-SELECT-REASON":"选择一个豁免的理由 :",
    "TAXES-US-MODAL-STEP3-REQUIRED-TIPS":"豁免类别",
        
    // STEP4
    "TAXES-US-MODAL-STEP4-TITLE":"豁免证书向导",
    "TAXES-US-MODAL-STEP4-REQUIRED-TIPS":"缺少必填字段",

    // STEP5
    "TAXES-US-MODAL-STEP5-TITLE":"豁免证书向导",
    "TAXES-US-MODAL-STEP5-DESCRIPTION":"已经确定了以下形式",
    "TAXES-US-MODAL-STEP5-TABLE-HEADER-JURSDICTIONS":"司法管辖区",
    "TAXES-US-MODAL-STEP5-TABLE-HEADER-FORM":"形式",
    "TAXES-US-MODAL-STEP5-TABLE-HEADER-ACTION":"行动",
    "TAXES-US-MODAL-STEP5-TABLE-CONTENT-UPLOAD":"上传的",
    "TAXES-US-MODAL-STEP5-TABLE-CONTENT-ACTION-UPLOAD":"上传",
    
    // STEP6
    "TAXES-US-MODAL-STEP6-TITLE":"上传表格",
    "TAXES-US-MODAL-STEP6-CONTENT-SELECTED":"已选定上传",
    "TAXES-US-MODAL-STEP6-CONTENT-UPLOAD":"单击选择要上传的文件",
    "TAXES-US-MODAL-STEP6-REQUIRED-TIPS":"请先上传文件再继续",
    "TAXES-US-MODAL-STEP6-ERROR-TIPS":"请上传 jpg, jpeg 或 png格式的文件!",
        
    // STEP7
    "TAXES-US-MODAL-STEP7-TITLE":"买家信息",
    "TAXES-US-MODAL-STEP7-FORM-COMPANY":" 公司名称",
    "TAXES-US-MODAL-STEP7-FORM-COMPANY-TIPS":"公司名称为必填项",
    "TAXES-US-MODAL-STEP7-FORM-ADDRESS":" 街道地址",
    "TAXES-US-MODAL-STEP7-FORM-ADDRESS-TIPS":"街道地址为必填项",
    "TAXES-US-MODAL-STEP7-FORM-COUNTRY":" 国家 / 地区",
    "TAXES-US-MODAL-STEP7-FORM-COUNTRY-EMPTY-TIPS":"没有匹配结果",
    "TAXES-US-MODAL-STEP7-FORM-COUNTRY-REQUIRED-TIPS":"国家 / 地区为必填项",
    "TAXES-US-MODAL-STEP7-FORM-STATE":"州/省",
    "TAXES-US-MODAL-STEP7-FORM-STATE-EMPTY-TIPS":"没有匹配结果",
    "TAXES-US-MODAL-STEP7-FORM-STATE-REQUIRED-TIPS":"州/省为必填项",
    "TAXES-US-MODAL-STEP7-FORM-CITY":"城市/城镇:",
    "TAXES-US-MODAL-STEP7-FORM-CITY-REQUIRED-TIPS":"城市为必填项",
    "TAXES-US-MODAL-STEP7-FORM-POSTAL":"邮政编码",
    "TAXES-US-MODAL-STEP7-FORM-POSTAL-REQUIRED-TIPS":"邮政编码为必填项",
    "TAXES-US-MODAL-STEP7-FORM-POSTAL-INVALID-TIPS":"邮政编码无效",
    "TAXES-US-MODAL-STEP7-FORM-PHONE-CODE":" 国家代码:",
    "TAXES-US-MODAL-STEP7-FORM-PHONE-CODE-REQUIRED-TIPS":"国家代码为必填项",
    "TAXES-US-MODAL-STEP7-FORM-PHONE-CODE-INVALID-TIPS":"多家代码无效",
    "TAXES-US-MODAL-STEP7-FORM-PHONE-NUMBER":"电话:",
    "TAXES-US-MODAL-STEP7-FORM-PHONE-NUMBER-REQUIRED-TIPS":"电话为必填项",
    "TAXES-US-MODAL-STEP7-FORM-PHONE-NUMBER-INVALID-TIPS":"电话无效!",
    "TAXES-US-MODAL-STEP7-FORM-EMAIL":"您的公司电子邮件",
    "TAXES-US-MODAL-STEP7-FORM-EMAIL-REQUIRED-TIPS":"电子邮箱为必填项",
    "TAXES-US-MODAL-STEP7-FORM-EMAIL-INVALID-TIPS":"电子邮箱无效!",

    // STEP8
    "TAXES-US-MODAL-STEP8-TITLE":"附加文件（可选）",
    "TAXES-US-MODAL-STEP8-DESCRIPTION":"请注明您是否有针对以下每个司法管辖区的额外文件",
    "TAXES-US-MODAL-STEP8-SELECTED":"已选定上传",
    "TAXES-US-MODAL-STEP8-CLICK":"单击选择要上传的文件",
    "TAXES-US-MODAL-STEP8-TIPS":`请附上您可能拥有的任何其他文件来支持上述豁免。如果您没有任何支持文件，请跳过此步骤`,
    "TAXES-US-MODAL-STEP8-TIPS-TYPE":"请上传 jpg, jpeg 或 png格式的文件!",
    "TAXES-US-MODAL-STEP8-TIPS-MAX":"附加文件的数量限制为最多 3 份，目前无法继续上传更多文件",
    
    // STEP9
    "TAXES-US-MODAL-STEP9-TITLE":"签名信息",
    "TAXES-US-MODAL-STEP9-DESCRIPTION":`通过输入我的姓名、职务和实体/组织的名称并在下方空白处签名；通过向需要收税的人员（卖方）提供可合理识别我为下方所列个人的附加信息；以及通过完成此交易，我理解并同意我以电子方式签署并提交与购买有关的此销售和使用税转售或免税证明，若非出示此电子转售或免税证明，卖方将向我收取销售税或使用税。我还保证此电子证明中包含的所有声明的真实性、完整性和准确性，并保证有权通过向卖方提交此电子证明而申请免除或免除销售税或使用税`,
    "TAXES-US-MODAL-STEP9-FORM-NAME":"姓名",
    "TAXES-US-MODAL-STEP9-FORM-NAME-REQUIRED-TIPS":"姓名为必填项",
    "TAXES-US-MODAL-STEP9-FORM-TITLE":"标题",
    "TAXES-US-MODAL-STEP9-FORM-TITLE-REQUIRED-TIPS":"标题为必填项",
    "TAXES-US-MODAL-STEP9-FORM-DATE":" 生效日期",
    "TAXES-US-MODAL-STEP9-FORM-DATE-REQUIRED-TIPS":" 生效日期为必填项",
    "TAXES-US-MODAL-STEP9-FORM-SIGNATURE":"签名",
    "TAXES-US-MODAL-STEP9-FORM-CLICK":"单击选择要上传的文件",
    "TAXES-US-MODAL-STEP9-FORM-DATE-UPLOAD":"上传",
    "TAXES-US-MODAL-STEP9-FORM-SIGNATURE-REQUIRED-TIPS":"请先上传文件再继续",
    "TAXES-US-MODAL-STEP9-FORM-SIGNATURE-TYPE-TIPS":"请上传 jpg, jpeg 或 png格式的文件!",
        
    // STEP10
    "TAXES-US-MODAL-STEP10-TITLE":"表格已完成",
    "TAXES-US-MODAL-STEP10-FORM-HEADER-FORMS":"形式",
    "TAXES-US-MODAL-STEP10-FORM-HEADER-JURSDICTIONS":"司法管辖区",
    "TAXES-US-MODAL-STEP10-FORM-HEADER-EXEMPTION":"豁免 ID",
    "TAXES-US-MODAL-STEP10-FORM-UPLOAD-FOR":"上传",
    "TAXES-US-MODAL-STEP10-FORM-ATTACH-FILE":"附加文件",

};

export { language }